import VRWorldImg from "../Assets/Images/VRWorld.jpg";
import DysonImg from "../Assets/Images/DysonProducts.jpeg";
import GamingSystemImg from "../Assets/Images/GamingSystem.jpg";
import GamingProductsImg from "../Assets/Images/GamingProducts.png";

export const products = [
  {
    image: VRWorldImg,
    category: "VR World",
    description:
      "Step into immersive experiences with cutting-edge virtual reality devices and environments.",
  },
  {
    image: DysonImg,
    category: "Dyson Products",
    description:
      "Explore advanced Dyson tech: Airwrap, Supersonic, V15 Detect, and more for smart living.",
  },
  {
    image: GamingSystemImg,
    category: "Professional & Gaming Systems",
    description:
      "Discover accessories and gear built for elite gaming: laptops, GPUs, monitors, and more.",
  },
  {
    image: GamingProductsImg,
    category: "Gaming Products",
    description:
      "Experience the latest PlayStation, Xbox, and Nintendo consoles designed for next-gen gaming.",
  },
];